<div class="container-fluid">
  <div class="row">
    <ng-template [ngIf]="totalImages">
      <div #scrollContainer class="col-12 p-0">
        <div class="container row p-0 m-0" style="max-width: 100%">
          <app-grid-gallery style="padding: 0px;"  [totalImages]="totalImages" [images]="arrayImages"
            [isAnnonymous]="isAnnonymous">
          </app-grid-gallery>
        </div>
        <button style="position: fixed;
        bottom: 1rem;
        background-color: #f25344;
        right: 1rem;" mat-mini-fab color="accent" (click)="scrollToTop(scrollContainer)"
          aria-label="Example icon button with a bookmark icon">
          <mat-icon>arrow_upward</mat-icon>
        </button>
        <div class="container row p-0 m-0" *ngIf="showImageLoading">
          <div class="col-6 col-sm-4 col-md-3 col-lg-2 p-0" *ngFor="let item of imageLoading">
            <div class="profile-img-section"></div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template [ngIf]="!totalImages">
      <div class="container row p-0 m-0">
        <div class="col-6 col-sm-4 col-md-3 col-lg-2 p-0" *ngFor="let item of imageLoading">
          <div class="profile-img-section"></div>
        </div>
      </div>
    </ng-template>
  </div>
</div>